import type { ServiceStatus } from "@/api/generated/ServiceStatus";

/**
 * Visual tone for the landing status badge. Mirrors the three real
 * `ServiceStatus` values from `/readyz`, plus `loading` for the window
 * before the first probe resolves.
 */
export type StatusTone = ServiceStatus | "loading";

export interface StatusBadge {
  tone: StatusTone;
  label: string;
}

const LABELS: Record<StatusTone, string> = {
  ok: "cluster up",
  degraded: "cluster degraded",
  down: "cluster down",
  loading: "checking status",
};

/**
 * Map a rolled-up `/readyz` status (or `undefined` while the probe is
 * in flight) to the badge's tone + copy. `fetchReady` never throws and
 * degrades a network failure to `down`, so this only ever sees a real
 * status or `undefined`.
 */
export function statusBadge(status: ServiceStatus | undefined): StatusBadge {
  const tone: StatusTone = status ?? "loading";
  return { tone, label: LABELS[tone] };
}
